import { useFieldContext } from "../form-context";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { MenuItem, Select, SxProps } from "@mui/material";

import { BaseField } from "./BaseField";

export interface SelectFieldProps {
  multiline?: boolean;
  options: Array<string>;
  fullWidth?: boolean;
  required?: boolean;
  sx?: SxProps;
}

export function SelectField({
  multiline,
  options,
  fullWidth,
  required,
  sx,
}: SelectFieldProps): JSX.Element {
  const { t } = useTranslation();
  const field = useFieldContext<string>();

  return (
    <BaseField fullWidth={fullWidth} required={required} sx={sx}>
      <Select
        value={field.state.value}
        multiline={multiline}
        fullWidth={fullWidth}
        onClose={field.handleBlur}
        onChange={(e) => field.handleChange(e.target.value)}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {t(`AS:dialog.requestQuote.select.${field.name}.option.${option}`)}
          </MenuItem>
        ))}
      </Select>
    </BaseField>
  );
}
